import type { DayOfWeek, SubscriptionFeeResponse } from '@mynt/backoffice-api-spec/billables'
import type { Template as ContractTemplate, Relation } from '@mynt/backoffice-api-spec/templates'
import { type PaymentFrequency, PaymentFrequencyType, type SubscriptionFee, type Template, type TemplateRelation, WeekDay } from './api'

export const mapTemplate = (template: ContractTemplate): Template => ({
  id: template.id,
  name: template.name,
  externalName: template.externalName,
})

export const mapTemplateRelation = (relation: Relation): TemplateRelation => ({
  id: relation.id,
  name: relation.name,
  relatives: relation.relatives,
})

export const mapSubscriptionFeeResponseToSubscriptionFee = (fee: SubscriptionFeeResponse): SubscriptionFee => ({
  paymentFrequency: mapSubscriptionFeePaymentFrequencyToPaymentFrequency(fee.paymentFrequency),
  isOverridden: fee.isOverridden,
  subscriptionFee: fee.subscriptionFee,
})

const mapSubscriptionFeePaymentFrequencyToPaymentFrequency = (
  paymentFrequency: SubscriptionFeeResponse['paymentFrequency'],
): PaymentFrequency | undefined => {
  if (!paymentFrequency) return undefined

  switch (paymentFrequency.type) {
    case 'YearlyOn': {
      return {
        type: PaymentFrequencyType.YEARLY,
        dayOfYear: paymentFrequency.day,
      }
    }

    case 'MonthlyOn': {
      return {
        type: PaymentFrequencyType.MONTHLY,
        dayOfMonth: paymentFrequency.day,
      }
    }

    case 'WeeklyOn': {
      return {
        type: PaymentFrequencyType.WEEKLY,
        dayOfWeek: mapDayOfWeekToWeekDay(paymentFrequency.dayOfWeek),
      }
    }

    case 'Daily': {
      return {
        type: PaymentFrequencyType.DAILY,
      }
    }
  }
}

const mapDayOfWeekToWeekDay = (dayOfWeek: DayOfWeek): WeekDay => {
  switch (dayOfWeek) {
    case 'MONDAY': {
      return WeekDay.MONDAY
    }

    case 'TUESDAY': {
      return WeekDay.TUESDAY
    }

    case 'WEDNESDAY': {
      return WeekDay.WEDNESDAY
    }

    case 'THURSDAY': {
      return WeekDay.THURSDAY
    }

    case 'FRIDAY': {
      return WeekDay.FRIDAY
    }

    case 'SATURDAY': {
      return WeekDay.SATURDAY
    }

    case 'SUNDAY': {
      return WeekDay.SUNDAY
    }
  }
}
